var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGreenArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 9.40039L9.5 0.40039L7.86805e-07 9.40039L6 9.40039L6 18.4004L13 18.4004L13 9.40039L19 9.40039Z",
    fill: "#34B53A"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenArrow);
export default __webpack_public_path__ + "static/media/green-arrow.516c2e41748344d183e9257c79b1dfd6.svg";
export { ForwardRef as ReactComponent };